import Board from '@src/models/Board';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToNewBoardByDivision,
  getRouteToNewBoardByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class BoardRepository {
  constructor() {
    this.board = new Board();
  }

  getCollectionPath(orgId, divId = null) {
    if (divId) {
      return getRouteToNewBoardByDivision(orgId, divId);
    }
    return getRouteToNewBoardByOrg(orgId);
  }

  async create({ data, orgId, divId = null }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId);
      this.board.setData(data);
      const res = await createOperation(collectionPath, null, this.board, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId);
      this.board.setData(data);
      const boardData = this.board.toUpdate();
      await createOperation(collectionPath, boardId, boardData, ACTIONS.UPDATE);
      return boardData;
    }).catch(error => {
      throw error;
    });
  }

  async delete({ orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId);
      await createOperation(collectionPath, boardId, null, ACTIONS.DELETE);
      return { id: boardId };
    }).catch(error => {
      throw error;
    });
  }
}

export default BoardRepository;
